import { OVERLAY_Z_INDEX_CEILING } from "./eva-dialog/eva-z-layers";

/** Élément cliqué ou survolé qui sert d'ancre au panneau (comme `overlayPanel.toggle($event)`). */
export function overlayAnchor(event: Event): Element | null {
  if (event.currentTarget instanceof Element) return event.currentTarget;
  return event.target instanceof Element ? event.target : null;
}

/** Z-index juste au-dessus de la couche la plus haute du DOM, hors tooltips / toasts. */
export function topOverlayZIndex(floor = 1000): number {
  let max = floor;
  document.querySelectorAll("*").forEach((el) => {
    const z = parseInt(window.getComputedStyle(el).zIndex, 10);
    if (!isNaN(z) && z > max && z < OVERLAY_Z_INDEX_CEILING) max = z;
  });
  return max + 1;
}
